<div fxLayout="column" fxLayoutAlign="center center" class="full-height">
    <app-indicator-values
        [isSpecialChart]="true"
        [visualization]="visualization"
        [options]="options"
        [series]="series"
        [points]="points"
        [company]="company"
    ></app-indicator-values>
</div>
